import { handleize } from "//decked.com/cdn/shop/t/467/assets/static.vpv-utils.js?v=167898115859071125761789150278";
import { animate, inView } from "//decked.com/cdn/shop/t/467/assets/static.vendor.min.js?v=161072099565793977701789150270";
import { getHeadingKeyframe } from "//decked.com/cdn/shop/t/467/assets/static.theme.js?v=48579292723385717811789150279";

var PDPVpvViewLinks = class extends HTMLElement {
  #visible;
  #hasFAQ;
  #included;

  constructor() {
    super();
    this.#visible = false;
    this.rootEl = document.querySelector('vpv-pdp-view-links');
    this.#hasFAQ = document.querySelector('.vpv-faq');
  }

  connectedCallback() {
    document.addEventListener("variant:change", () => {
      this.checkForLinks();
      this.render();
    });

    document.addEventListener("content:update", () => {
      this.checkForLinks();
      this.render();
    });

    this.checkForLinks();
    this.render();
  }

  checkForLinks() {
    this.#hasFAQ = document.querySelector('.vpv-faq');
    this.#visible = document.querySelector('.shopify-section--tech-specs .tech-specs__definition-list') || window.__VPV?.pdp?.remainingVariants?.length == 1;
    this.#included = document.querySelector('.product-info__promo-drawer x-drawer');
  }

  scrollToSelector(selector) {
    const element = document.querySelector(selector);
    if(!element) return;
    
    element.scrollIntoView({behavior: "smooth"});

  }

  #createViewLink(name, selector, controls) {
    const $a = document.createElement("a");
    $a.innerText = `${name}`;
    $a.id = handleize(name);
    $a.classList.add("view-link", "link");
    $a.setAttribute("aria-controls", controls);
    $a.setAttribute("role", "button");
    if(selector){
      $a.addEventListener("click", () => {
        this.scrollToSelector(selector);
      });
    }

    this.rootEl.appendChild($a);
  }

  render() {
    this.rootEl.innerHTML = '';

    if (this.#visible) {
      this.#createViewLink('View Tech Specs', '.shopify-section--tech-specs');
    }

    if (this.#included) {
      this.#createViewLink('What\'s included', null, this.#included.id);
    }

    if (this.#hasFAQ) {
      this.#createViewLink('View FAQ', '.vpv-faq');
    }

  }
};

if (!window.customElements.get("vpv-pdp-view-links")) {
  window.customElements.define("vpv-pdp-view-links", PDPVpvViewLinks);
}

var ProductRating = class extends HTMLElement {

  static get observedAttributes() { return ['rating', 'count']; }

  constructor() {
    super();
    this.link = this.querySelector('a.rating');
    this.stars = this.querySelector('.rating__stars');
    this.text = this.querySelector('.rating__text');
  }

  attributeChangedCallback(attr, oldVal, newVal) {
    switch (attr) {
      case "rating":
        this.stars.style.setProperty('--rating', newVal);
      case "count":
        if(newVal != oldVal){
          if(newVal == 0){
            this.text.innerHTML = `No Reviews`;
          }else{
            this.text.innerHTML = `${newVal} Review${newVal > 1 ? 's' : ''}`;
          }
        }
    }
  }

  connectedCallback() {

    if(this.getAttribute('live') == "true"){
      window.addEventListener("remainingVariants:change", ev => this.updateRating(ev.detail));
      this.link.addEventListener('click', (e) => {
        const ratingsWidget = document.querySelector('.yotpo-main-widget');
        if(ratingsWidget){
          e.preventDefault();
          e.stopPropagation();
          ratingsWidget.scrollIntoView({behavior: "smooth"});
        }
      });
    }
  }

  updateRating() {
    const variant = window.__VPV.pdp?.remainingVariants && window.__VPV.pdp.remainingVariants[0];
    if(variant?.product?.reviewsAverage){
      this.setAttribute("rating",  variant.product.reviewsAverage.value);
      this.setAttribute("count",  variant.product.reviewsCount.value);
    }
  }

}

if (!window.customElements.get("product-rating")) {
  window.customElements.define("product-rating", ProductRating);
}

class TextOptionInput extends HTMLElement {
  constructor() {
    super();
    this.valueInput = this.querySelector('.text-option__value');
    this.textInput = this.querySelector('.text-option__text');
    this.optionsInputs = this.querySelectorAll('.text-option__option');
    this.options = [];
    this.valueIndex = -1
    Array.from(this.optionsInputs).forEach(option => {
      this.options.push(option.value.toLowerCase().trim());
    });
  }

  connectedCallback() {
    this.textInput.addEventListener('change', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
    this.textInput.addEventListener('keyup', () => {
      const value = this.textInput.value.toLowerCase().trim();
      const valueIndex = this.options.indexOf(value);
      console.log("valueIndex", valueIndex);
      if(valueIndex > -1){
        const activeInput = this.optionsInputs[valueIndex];
        this.valueIndex = valueIndex;
        this.textInput.classList.remove('text-error');
        this.valueInput.value = activeInput.value;
        this.valueInput.dispatchEvent(new CustomEvent("change", {
          bubbles: true,
          detail: {
            value: this.valueInput.value
          }
        }));
      }else{
        if(this.valueIndex != valueIndex){
          console.log("reset");
          this.valueInput.value = '';
          this.valueInput.dispatchEvent(new CustomEvent("change", {
            bubbles: true,
            detail: {
              value: this.valueInput.value
            }
          }));
        }
      }
    });
    this.textInput.addEventListener('blur', () => {
      const value = this.textInput.value.toLowerCase().trim();
      const valueIndex = this.options.indexOf(value);
      if(valueIndex == -1){
        this.textInput.classList.add('text-error');
      }
    });
  }

}

if (!window.customElements.get("text-option-input")) {
  window.customElements.define("text-option-input", TextOptionInput);
}

class DynamicVariantSwatch extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute('product-id');
    this.image = this.querySelector('.media-swatch img');
    this.link = this.querySelector('a');
    this.shouldUpdateImage = this.getAttribute('update-image') == "true";
  }

  connectedCallback() {
    this.variantsScript = this.querySelector('#variantData-' + this.productId );
    try{
      this.variants = JSON.parse(this.variantsScript.innerHTML);
    }catch(e){
      console.error("Error parsing variants", e);
    }

    window.addEventListener('variant:change', (e) => {
      if(!e.detail.variant) return;
      this.updateSwatch(e.detail.variant);
    });

    const initialVariant = __VPV?.pdp?.initialVariant;
    if(initialVariant){
      this.updateSwatch(initialVariant);
    }
  }

  updateSwatch(variant) {
    const swatchVariant = this.variants.find(v => v.option1 == variant.option1);
    if(!swatchVariant) return;
    if(this.shouldUpdateImage){
      //replace image src and srcset
      this.image.src = swatchVariant.featured_image;
      let srcset = this.image.getAttribute('srcset');
      srcset = srcset.replace(/\/\/[^?]+/g, swatchVariant.featured_image.replace(/\?.*/, ''));
      this.image.setAttribute('srcset', srcset);
    }
    this.updateLink(swatchVariant);
  }

  updateLink(variant) {
    const url = new URL(this.link.href);
    url.searchParams.set('variant', variant.id);
    this.link.href = url.toString();
  }

}

if (!window.customElements.get("dynamic-variant-swatch")) {
  window.customElements.define("dynamic-variant-swatch", DynamicVariantSwatch);
}

class ArticlePullQuote extends HTMLElement {
  connectedCallback() {
    const quoteContent = this.querySelector('[reveal-on-scroll="true"]');
    if(quoteContent){
      inView(this, () => animate(...getHeadingKeyframe(quoteContent)), { margin: "0px 0px 0px 0px" });
    }
  }
}

if (!window.customElements.get("article-pull-quote")) {
  window.customElements.define("article-pull-quote", ArticlePullQuote);
}